var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52867 8.47133C5.40369 8.34631 5.33348 8.17678 5.33348 8C5.33348 7.82322 5.40369 7.65369 5.52867 7.52867L9.3 3.75733C9.3615 3.69366 9.43506 3.64287 9.5164 3.60793C9.59773 3.57299 9.68521 3.5546 9.77373 3.55383C9.86225 3.55306 9.95004 3.56993 10.032 3.60345C10.1139 3.63697 10.1883 3.68647 10.2509 3.74907C10.3135 3.81167 10.363 3.8861 10.3965 3.96803C10.4301 4.04996 10.4469 4.13775 10.4462 4.22627C10.4454 4.31479 10.427 4.40227 10.3921 4.4836C10.3571 4.56494 10.3063 4.6385 10.2427 4.7L6.94267 8L10.2427 11.3C10.3641 11.4257 10.4313 11.5941 10.4298 11.7689C10.4283 11.9437 10.3582 12.1109 10.2345 12.2345C10.1109 12.3582 9.94373 12.4283 9.76893 12.4298C9.59414 12.4313 9.42573 12.3641 9.3 12.2427L5.52867 8.47133Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesBack);
export default __webpack_public_path__ + "static/media/files-back.f3d66d2f2255a8157548cf675915e327.svg";
export { ForwardRef as ReactComponent };